import inventoryText from "./inventoryI18n.js";
import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTachometerAlt,
  faUsers,
  faUser,
  faWifi,
  faList,
  faCog,
} from "@fortawesome/free-solid-svg-icons";
import { NavLink } from "react-router-dom";
import AddInventory from "./InventoryAdd";

import InventoryTabs from "./InventoryTabs";
import "./Inventory.css";
function Inventory() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const handleShow = () => setShow(true);


  return (
    <div className="Plans">
      <div className="main">
        <div>
          <button onClick={handleShow} className="AddClient">{inventoryText("inventory.Add")}</button>
          <NavLink
            exact
            to="/inventory/products"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
            {inventoryText("inventory.Products")}
          </NavLink>

          <NavLink
            exact
            to="/inventory/services"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
            {inventoryText("inventory.Services")}
          </NavLink>

          <NavLink
            exact
            to="/inventory/suppliers"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
            {inventoryText("inventory.Suppliers")}
          </NavLink>
          <NavLink
            exact
            to="/inventory/warehouses"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon icon={faUser} style={{ marginRight: "10px" }} />{" "}
            {inventoryText("inventory.Warehouses")}
          </NavLink>
          <NavLink
            exact
            to="/inventory/purchases"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon
              icon={faList}
              style={{ marginRight: "10px" }}
            />{" "}
            {inventoryText("inventory.Purchases")}
          </NavLink>
          <NavLink
            exact
            to="/inventory/evaluations"
            activeClassName="active"
            className="AddClient"
            style={{ textDecoration: "none" }}
          >
            <FontAwesomeIcon
              icon={faList}
              style={{ marginRight: "10px" }}
            />{" "}
            {inventoryText("inventory.Evaluation")}
          </NavLink>
        </div>
        <InventoryTabs />
      </div>
      <Modal show={show} onHide={handleClose}>
        <div className="forma">
          <Modal.Header closeButton>
            <Modal.Title>{inventoryText("inventory.AddItems")}</Modal.Title>
          </Modal.Header>
          <AddInventory closeModal={handleClose} />
        </div>
      </Modal>
    </div>
  );
}

export default Inventory;
